import { clusterStore } from '@entities/cluster'
import { painterStore } from '@entities/painter'
import { useSession } from '@entities/session'
import { usersStore } from '@entities/user'
import { useAction, useAppSelector } from '@shared/lib/redux'
import { useCallback, useEffect } from 'react'

// TODO: Задуматься над переносом этой логики в Epic
export const useObserveUsersList = () => {
  const { isAuthorized } = useSession()
  const ageFilter = useAppSelector(usersStore.selectors.selectUsersAge)
  const genderFilter = useAppSelector(usersStore.selectors.selectUsersGender)

  const selectedCluster = useAppSelector(
    clusterStore.selectors.selectSelectedCluster
  )

  // const isPaintModeActive = useAppSelector(
  //   painterStore.selectors.selectIsPaintStarted
  // )
  const painterObject = useAppSelector(painterStore.selectors.selectPainter)

  let radius = null
  let lat = null
  let long = null
  // TODO: Разобраться, почему это не нужно
  // if (isPaintModeActive && painterObject) {
  if (painterObject) {
    radius = Math.floor(painterObject.radius)
    lat = painterObject.coordinates[0]
    long = painterObject.coordinates[1]
  }
  if (selectedCluster) {
    radius = Math.floor(selectedCluster.radius)
    lat = selectedCluster.coordinates[1]
    long = selectedCluster.coordinates[0]
  }

  const getUsers = useAction(usersStore.actions.getUsersStart)

  useEffect(() => {
    const isEnabled =
      Boolean(lat) && Boolean(long) && Boolean(radius) && Boolean(isAuthorized)
    if (!isEnabled) return
    getUsers({
      lat: lat ?? 0,
      long: long ?? 0,
      radius: radius ?? 0,
      age: ageFilter.join(','),
      gender: genderFilter
    })
  }, [lat, long, radius, genderFilter, ageFilter, getUsers, isAuthorized])
}

export const useToggleDiagramsOpen = () => {
  const toggle = useAction(usersStore.actions.toggleDiagramsOpen)
  return {
    openDiagrams: useCallback(() => toggle(true), [toggle]),
    closeDiagrams: useCallback(() => toggle(false), [toggle])
  }
}

export const useToggleSearchOpen = () => {
  const toggle = useAction(usersStore.actions.toggleSearchOpen)
  return {
    openSearch: useCallback(() => toggle(true), [toggle]),
    closeSearch: useCallback(() => toggle(false), [toggle])
  }
}

export const useToggleFiltersOpen = () => {
  const toggle = useAction(usersStore.actions.toggleFiltersOpen)
  return {
    openFilters: useCallback(() => toggle(true), [toggle]),
    closeFilters: useCallback(() => toggle(false), [toggle])
  }
}

export const useSetAgeFilter = () => {
  return useAction(usersStore.actions.setAgeFilter)
}
export const useSetGenderFilter = () => {
  return useAction(usersStore.actions.setGenderFilter)
}

export const useResetUsers = () => {
  return useAction(usersStore.actions.reset)
}

export const useUsersReportGenderFilter = () => {
  const genderFilter = useAppSelector(
    usersStore.selectors.selectReportGenderFilter
  )
  const setGenderFilter = useAction(usersStore.actions.setGenderReportFilter)
  return {
    genderFilter,
    setGenderFilter
  }
}

export const useUsersReportAgeFilter = () => {
  const ageFilter = useAppSelector(usersStore.selectors.selectReportAgeFilter)
  const setAgeFilter = useAction(usersStore.actions.setAgeReportFilter)
  return {
    ageFilter,
    setAgeFilter
  }
}

export const useUsersReportPhoneFilter = () => {
  const phoneFilter = useAppSelector(
    usersStore.selectors.selectReportPhoneFilter
  )
  const setPhoneFilter = useAction(usersStore.actions.setPhoneReportFilter)
  return {
    phoneFilter,
    setPhoneFilter
  }
}
